import { useState } from 'react';
import { ReactComponent as ChatSmileySvg } from '../../assets/svg/chat-smiley.svg';
import { ReactComponent as ChevronDownSvg } from '../../assets/svg/chevron-down.svg';
import { formatDate } from '../../lib/utils';

const Feedback = ({ type = '', feedback }) => {
  const [collapsed, setCollapsed] = useState(true);

  const handleCollapseFeedback = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className='relative rounded-xl px-3 py-2 bg-secondary'>
      <div className='flex items-end gap-2 mb-2'>
        <div className='flex items-center gap-1 font-bold text-white'>
          <ChatSmileySvg />
          <div>{type ? `${type} Feedback` : 'Feedback'}</div>
        </div>
      </div>
      <p
        className={`text-xs text-white ${
          collapsed ? 'line-clamp-2' : 'max-h-96 overflow-auto'
        }`}
      >
        {feedback.length === 0 && 'No feedback today.'}
        {feedback.length > 0 &&
          feedback.map((feed, index) => (
            <span key={index}>
              <span className='font-bold'>
                {formatDate(new Date(feed.date))}
              </span>{' '}
              {feed.content}
              <br />
              <br />
            </span>
          ))}
      </p>
      {feedback.length > 0 && (
        <div className='flex justify-center items-center text-white'>
          <button
            className='flex items-center gap-1 text-xs'
            onClick={handleCollapseFeedback}
          >
            <ChevronDownSvg
              className={`size-4 transition-transform duration-500 ${
                collapsed ? '' : 'rotate-180'
              }`}
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default Feedback;
